export default {
  inject: ['load'],
  data() {
    return {
      allVertigoOtherSpecificationsForOther: [],
      vertigoOtherSpecification: null,
    };
  },
  methods: {
    getListOfVertigoOtherSpecificationsForOther: function () {
      if (!this.load.val) {
        this.load.val = true;
      }
      this.$store.dispatch('getAllVertigoOtherSpecifications').then(() => {
        if (this.$store.state.vertigoOtherSpecificationModule.successFlag) {
          this.allVertigoOtherSpecificationsForOther =
            this.$store.state.vertigoOtherSpecificationModule.allVertigoOtherSpecifications;
          if (this.load.val) {
            this.load.val = false;
          }
        } else {
          if (this.load.val) {
            this.load.val = false;
          }
          if (this.$store.state.vertigoOtherSpecificationModule.errorStatus) {
            this.$store.dispatch('refreshToken').then(() => {
              if (this.$store.state.userModule.successFlag) {
                this.getListOfVertigoOtherSpecificationsForOther();
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else {
            this.showError();
          }
        }
      });
    },
    getVertigoOtherSpecificationFunction: function (id) {
      if (!this.load.val) {
        this.load.val = true;
      }
      this.$store.dispatch('getVertigoOtherSpecification', id).then(() => {
        if (this.$store.state.vertigoOtherSpecificationModule.successFlag) {
          this.vertigoOtherSpecification =
            this.$store.state.vertigoOtherSpecificationModule.vertigoOtherSpecification;
          if (this.load.val) {
            this.load.val = false;
          }
        } else {
          if (this.load.val) {
            this.load.val = false;
          }
          if (this.$store.state.vertigoOtherSpecificationModule.errorStatus) {
            this.$store.dispatch('refreshToken').then(() => {
              if (this.$store.state.userModule.successFlag) {
                this.getVertigoOtherSpecificationFunction(id);
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else {
            this.showError();
          }
        }
      });
    },
    showError: function () {
      this.snackText = this.$store.state.vertigoOtherSpecificationModule.error;
      this.$refs.snackRef.snackModel = true;
      this.snackColor = '#FF5252';
      this.snakIcon = 'mdi-information';
    },
  },
};
